import * as React from "react"

import { cn } from "../../lib/utils"
import { fmtDate, weekNo } from "../../lib/dateFormat"

/**
 * The ISO week of a date, as a small grey badge: W43.
 * Site and office both refer to work by week number, so every date the app
 * shows carries its week next to it.
 */
export const WeekBadge = ({ value, week, className }) => {
  const w = week ?? weekNo(value)
  if (!w) return null
  return (
    <span
      className={cn(
        "ml-1 inline-block rounded-sm bg-muted px-1 align-middle text-[0.7em] font-semibold leading-[1.45] text-muted-foreground",
        className
      )}
      title={`ISO week ${w}`}
      data-testid="week-badge"
    >
      W{w}
    </span>
  )
}

/** A date plus its week badge: "21.10.2026 W43". */
export const DateText = ({ value, empty = "—", className, badgeClassName }) => {
  const text = fmtDate(value)
  if (!text) return <span className={className}>{empty}</span>
  return (
    <span className={cn("whitespace-nowrap", className)}>
      {text}
      <WeekBadge value={value} className={badgeClassName} />
    </span>
  )
}

export default DateText
